<template>
  <!-- <v-snackbar v-model="showSnackbar" :timeout="timeout"> Updating page... </v-snackbar> -->

  <router-view />
</template>

<script>
  const cookies = require("js-cookie");

  import { mapState } from "pinia";
  import UserService from "@/services/UserService";
  import config from "@/config/index";
  import { useMainStore } from "@/stores/store";
  import { useAppStore } from "@/stores/appStore";
  export default {
    components: {},
    data: () => ({
      dialogVisible: false, // controls visibility of dialog
      timeout: 2000,
      snackbarDismissed: false,
      forceVisible: false,
    }),
    computed: {
      ...mapState(useMainStore, ["user", "workspaces", "kyano"]),
      appStore() {
        return useAppStore();
      },
      isActiveWorkspaceNull() {
        return this.user.active_workspace_id === null;
      },

      showSnackbar: {
        get() {
          // Is 'ie forceVisible? Of updatingpage & niet handmatig gesloten?
          return (
            (this.appStore.updatingpage || this.forceVisible) && !this.snackbarDismissed
          );
        },
        set(val) {
          if (!val) {
            this.snackbarDismissed = true;
          }
        },
      },
    },
    methods: {
      closeSnackbar() {
        // Handmatige sluiting mag pas na 1s
        if (!this.snackbarShownAt || Date.now() - this.snackbarShownAt > 1000) {
          this.snackbarDismissed = true;
          this.forceVisible = false;
        }
      },
      resetSnackbarState() {
        this.snackbarDismissed = false;
        this.forceVisible = false;
        this.snackbarShownAt = Date.now();
      },
      checkActiveWorkspace() {
        if (this.user && this.user.is_staff) {
          this.$router.push("/admin");
        }

        if (this.user && !this.user.is_staff) {
          if (this.user && this.user.active_workspace) {
            const activeWorkspace = this.user.active_workspace;
            if (activeWorkspace.status === "inactive") {
              this.$router.push("/workspaces");
            } else if (this.user.active_workspace_id === null) {
              this.$router.push("/workspaces");
            }
          } else {
            console.log("No active workspace found");
          }
        }
      },
    },
    beforeMount() {
      this.$router.isReady().then(async () => {
        const store = useMainStore(); // Pinia store
        const token = cookies.get("kyano_access_token");

        const isAuthPage = [
          "/login",
          "/register",
          "/password-reset",
          "/password-set",
          "/go",
          "/esign",
        ].some((route) => this.$route.path.startsWith(route));

        // Check of de user al geladen is
        if (!token) {
          if (!isAuthPage) {
            return location.replace(`${config.url.login}/login`);
          }
          return; // We zitten al op een toegestane route
        }

        if (!store.user_loaded) {
          try {
            const data = await UserService.getCurrentUser();
            if (data.language) {
              this.$i18n.locale = data.language;
            }
            store.$patch({
              user: data,
              workspaces: data.workspaces,
              active_workspace_id: data.active_workspace_id,
              user_loaded: true, // Markeer als geladen
            });
          } catch (err) {
            console.error("Error loading user:", err);
            cookies.remove("kyano_access_token", {
              domain: config.cookiedomain,
              path: "/",
            });
            cookies.remove("kyano_user", { domain: config.cookiedomain, path: "/" });
            location.replace(
              `${config.url.login}/login?r=${encodeURIComponent(location.href)}`
            );
          }
        }
      });
    },
    mounted() {
      if (this.user && this.user.active_workspace) {
        this.checkActiveWorkspace();
      }
      if (this.user && this.user.language) {
        this.$i18n.locale = this.user.language;
      } else {
        // Fallback to default language
        this.$i18n.locale = "en";
      }
    },

    watch: {
      isActiveWorkspaceNull(newVal) {
        if (newVal) {
          this.$router.push("/workspaces");
        }
      },
      "appStore.updatingpage"(val) {
        if (val) {
          // Reset alle states en toon snackbar
          this.resetSnackbarState();
        } else if (this.snackbarShownAt) {
          // Als updatingpage uitgaat vóór 1s: forceVisible!
          const elapsed = Date.now() - this.snackbarShownAt;
          if (elapsed < 1000) {
            this.forceVisible = true;
            setTimeout(() => {
              this.forceVisible = false;
            }, 1000 - elapsed);
          } else {
            this.forceVisible = false;
          }
        }
      },
    },
  };
</script>
